module.exports = __webpack_public_path__ + "img/header-eixoeu.f78413d1.svg";